import type { IconDef } from '../types';

export const downArrow: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M20.5498 14.376C20.1597 13.9858 19.5294 13.9858 19.1392 14.376L12.9166 20.5986V1.00042C12.9166 0.450188 12.4664 0 11.9162 0C11.366 0 10.9158 0.450188 10.9158 1.00042V20.5986L4.70321 14.376C4.31305 13.9858 3.68278 13.9858 3.29262 14.376C2.90246 14.7662 2.90246 15.3964 3.29262 15.7866L11.2159 23.7099C11.416 23.91 11.6661 24 11.9262 24C12.1863 24 12.4364 23.9 12.6365 23.7099L20.5598 15.7866C20.95 15.3964 20.95 14.7662 20.5598 14.376H20.5498Z',
    },
  ],
};
